import React, { useContext, useState, useEffect, Fragment } from "react";
import { combineValidators, isRequired } from "revalidate";
import { Link, RouteComponentProps } from "react-router-dom";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { CategoryFormValues } from "../../../app/models/category";
import { v4 as uuid } from "uuid";
import { Segment, Form, Button, Grid } from "semantic-ui-react";
import TextInput from "../../../app/common/form/TextInput";
import { Form as FinalForm, Field } from "react-final-form";
import TextAreaInput from "../../../app/common/form/TextAreaInput";
import { observer } from "mobx-react-lite";

const validate = combineValidators({
  code: isRequired({ message: "Sigla é obrigatório" }),
  name: isRequired({ message: "Nome é obrigatório" }),
});

interface DetailParams {
  id: string;
}

const CategoryForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {
    createCategory,
    editCategory,
    submitting,
    loadCategory,
    deleteCategory,
    target,
  } = rootStore.categoryStore;

  const [category, setCategory] = useState(new CategoryFormValues());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (match.params.id) {
      setLoading(true);
      loadCategory(match.params.id)
        .then((category) => setCategory(new CategoryFormValues(category)))
        .finally(() => setLoading(false));
    }
  }, [loadCategory, match.params.id]);

  const handleFinalFormSubmit = (values: any) => {
    const { ...category } = values;
    if (!category.id) {
      let newCategory = {
        ...category,
        id: uuid(),
      };
      createCategory(newCategory);
    } else {
      editCategory(category);
    }
  };

  return (
    <Fragment>
      {category.id ? <h1>Editar Categoria</h1> : <h1>Nova Categoria</h1>}
      <Segment clearing>
        <FinalForm
          validate={validate}
          initialValues={category}
          onSubmit={handleFinalFormSubmit}
          render={({ handleSubmit, invalid, pristine }) => (
            <Form onSubmit={handleSubmit} loading={loading}>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={4}>
                    <Field
                      name="code"
                      title="Sigla"
                      placeholder="Sigla"
                      value={category.code}
                      component={TextInput}
                      disabled={category.id ? true : false}
                    />
                  </Grid.Column>
                  <Grid.Column width={12}>
                    <Field
                      name="name"
                      title="Nome"
                      placeholder="Nome"
                      value={category.name}
                      component={TextInput}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Field
                      name="description"
                      title="Descrição"
                      placeholder="Descrição"
                      value={category.description}
                      rows={4}
                      component={TextAreaInput}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Button
                      loading={submitting}
                      disabled={loading || invalid || pristine}
                      floated="right"
                      positive
                      type="submit"
                      content="Salvar"
                    />
                    <Button
                      as={Link}
                      to="/admin/categorias"
                      disabled={loading}
                      floated="right"
                      type="button"
                      content="Cancelar"
                    />
                    {category.id && (
                      <Button
                        loading={target === category.id && submitting}
                        disabled={loading}
                        onClick={(e) => {
                          deleteCategory(e, category.id!);
                          setCategory(new CategoryFormValues());
                        }}
                        floated="right"
                        color="red"
                        content="Excluir"
                      />
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          )}
        />
      </Segment>
    </Fragment>
  );
};

export default observer(CategoryForm);
